
<div class="pageHeader" [ngClass]="headerSize ? smallHeader : bigHeader">
    <div class="blurrer pageHeader" [ngClass]="headerSize ? smallHeader : bigHeader"></div>
    <div class="headerBox rowRight">
            <a class="pageHeaderBack" (click)="navigateToPage(backRoute)" [ngClass]="headerAnim">
                <span class="arrow left"></span>
            </a>
            <div class="pageHeaderTitle" [ngClass]="headerAnim">
                    <div class="pageHeaderContent">{{ pageTitle | translate }}</div>
            </div>
    </div>
    <ng-content></ng-content>
</div>